export default __webpack_public_path__ + "static/media/landingInfographic3.8efa71c4.png";